// Standardized memory logging for debugging memory leaks and excessive memory usage in the CodeBook feature.

const fmtMB = (bytes) => `${(bytes / 1024 / 1024).toFixed(1)}MB`;

export const logMemory = (label) => {
  if (performance?.memory) {
    const { usedJSHeapSize, totalJSHeapSize, jsHeapSizeLimit } = performance.memory;
    console.log(
      `[MEM] ${label} — used: ${fmtMB(usedJSHeapSize)} / total: ${fmtMB(
        totalJSHeapSize
      )} / limit: ${fmtMB(jsHeapSizeLimit)}`
    );
  } else {
    console.log(`[MEM] ${label} — performance.memory unavailable (use Chrome/Edge)`);
  }
};

export const logDataSize = (label, data) => {
  try {
    const json = JSON.stringify(data);
    const bytes = json ? json.length : 0; // rough proxy, 1 char ≈ 1 byte for ASCII-heavy JSON
    const count = Array.isArray(data) ? data.length : "n/a";
    console.log(`[SIZE] ${label} — approx ${fmtMB(bytes)}, top-level items: ${count}`);
  } catch (e) {
    console.log(`[SIZE] ${label} — could not stringify (circular or too large)`);
  }
};
let callCounters = {};
export const logFetchCall = (key) => {
  callCounters[key] = (callCounters[key] || 0) + 1;
  console.log(`[FETCH] ${key} — invocation #${callCounters[key]}`, new Error().stack?.split("\n")[2]?.trim());
};